import { z } from 'zod';

export const MeasurementGroupTypes = ['PLANT', 'LINE', 'LOAD'] as const;

export enum MeasurementGroupTypesEnum {
	PLANT = 'PLANT',
	LINE = 'LINE',
	LOAD = 'LOAD'
}

const itemSchema = z.object({
	value: z.string(),
	label: z.string()
});

export const createMeasurementGroupSchema = z
	.object({
		name: z.string().nonempty('Name is required'),
		type: z.nativeEnum(MeasurementGroupTypesEnum, { message: 'Measurement group type is required' }),
		processObjectList: z.array(itemSchema).nonempty('At least one process object is required'),
		objectList: z.array(itemSchema).optional()
	})
	.refine(
		data => {
			if (data.type) {
				return data.objectList && data.objectList.length > 0;
			}
			return true;
		},
		{
			message: 'At least one selection is required',
			path: ['obList']
		}
	);

export type CreateMeasurementGroupFormSchema = z.infer<typeof createMeasurementGroupSchema>;
